export default "__VITE_ASSET__D4bowJi2__"